import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import IconSelectorField from '../icon-selector/IconSelectorField';

// ----------------------------------------------------------------------

export default function RHFIconSelector({ name, helperText, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <IconSelectorField
                    {...field}
                    onChange={(value) => field.onChange(value)}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                />
            )}
        />
    );
}

RHFIconSelector.propTypes = {
    name: PropTypes.string.isRequired,
    helperText: PropTypes.string,
};
